import { useCallback, useEffect, useState } from "react";
import { fetchTodoSummary } from "../apis/todos";
import useAutoRefresh from "../hooks/useAutoRefresh";
import "../styles/components/TodosOverview.css";

const toCount = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const TILES = [
  { key: "today", label: "Due Today", tone: "blue" },
  { key: "pending", label: "Pending", tone: "orange" },
  { key: "overdue", label: "Overdue", tone: "red" },
  { key: "completed", label: "Completed", tone: "green" },
  { key: "total", label: "Total", tone: "purple" },
];

const TodosOverview = () => {
  const [summary, setSummary] = useState(null);

  const loadSummary = useCallback(async () => {
    try {
      const response = await fetchTodoSummary();
      if (response?.description || response?.error) return;
      setSummary(response);
    } catch (error) {
    }
  }, []);

  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  useAutoRefresh(() => loadSummary());

  if (!summary) return null;

  return (
    <section className="todos-overview" aria-label="My Todos">
      <article className="todos-overview-card">
        <div className="todos-overview-head">
          <span className="todos-overview-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <rect
                x="4"
                y="3.5"
                width="16"
                height="17"
                rx="3"
                fill="none"
                stroke="#2f6fe0"
                strokeWidth="1.8"
              />
              <path
                d="M8.2 9.4l1.6 1.6 3-3M8.2 15.4l1.6 1.6 3-3"
                fill="none"
                stroke="#2f6fe0"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.5 9.5h1.6M15.5 15.5h1.6"
                stroke="#2f6fe0"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <div>
            <h3 className="todos-overview-title">My Todos</h3>
            <p className="todos-overview-subtitle">
              Your personal checklist at a glance
            </p>
          </div>
        </div>

        <div className="todos-tile-row">
          {TILES.map((tile) => (
            <div className={`todos-tile ${tile.tone}`} key={tile.key}>
              <p className="todos-tile-value">{toCount(summary[tile.key])}</p>
              <p className="todos-tile-label">{tile.label}</p>
            </div>
          ))}
        </div>
      </article>
    </section>
  );
};

export default TodosOverview;
